import { formatInTimeZone } from "date-fns-tz";
import { Card, Icon } from "@/components/atoms";
import { BookingDetails } from "@/redux/slices/booking/types";
import { DetailField } from "../../../common/DetailField";

interface DistanceSectionProps {
  booking: BookingDetails;
}

export const DistanceSection = ({ booking }: DistanceSectionProps) => {
  const { distance, dates } = booking;

  const formatDistance = (distanceValue: number) => {
    return `${distanceValue.toFixed(1)} km`;
  };

  return (
    <Card className="space-y-3 p-2.5">
      <DetailField
        leading={<Icon name="Routing" size="lg" className="text-neutral-dark-gray" />}
        label="Actual Distance"
        value={distance?.actualDistance ? formatDistance(distance.actualDistance) : "-"}
      />

      <DetailField
        leading={<Icon name="Routing" size="lg" className="text-neutral-dark-gray" />}
        label="Estimated Distance"
        value={distance?.estimatedDistance ? formatDistance(distance.estimatedDistance) : "-"}
      />

      <DetailField
        leading={<Icon name="TickCircle" size="lg" className="text-neutral-dark-gray" />}
        label="Driver Closed Job"
        value={dates.driverCloseJob ? formatInTimeZone(new Date(dates.driverCloseJob), dates.timezone, "h:mm:ss a") : "-"}
      />
    </Card>
  );
};
